import { Component, DestroyRef, HostBinding } from '@angular/core';
import { Task, Workflow } from '@Core/models/codegen/area.models';
import { UserContext } from '@Core/contexts/user-context';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import _ from "lodash";
import { TaskTimer, TaskUtils } from '@Core/utils/task-utils';
import { ModelUtils } from '@Core/utils/model-utils';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TaskTimerService } from '@Work/Services/task-timer.service';
import { environment } from 'src/environments/environment';

@Component({
    standalone: false,
    selector: 'user-task-timer',
    templateUrl: './user-task-timer.component.html',
    styles: [`
        :host(.aurora-enabled) {
            display: contents;
        }
    `]
})
export class UserTaskTimerComponent {

    @HostBinding('class.aurora-enabled') public readonly auroraEnabled = environment.auroraV1 === 'true';

    private ngUnsubscribe: Subject<boolean> = new Subject();

    public userTaskTimer: TaskTimer = null;
    public workflow: Workflow = null;

    constructor(
        private userContext: UserContext,
        private taskTimerService: TaskTimerService,
        private router: Router,
        private destroyRef: DestroyRef
    ) { }

    ngOnInit(): void {
        combineLatest([
            this.userContext.getStore<Task>(new Task()).values,
            this.userContext.getStore<Workflow>(new Workflow()).values,
            this.taskTimerService.isInitialized$
        ])
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(([tasks, workflows]) => {
            const filteredTasks = this.filterTasks(tasks);

            this.userTaskTimer = this.taskTimerService.getMostImminentTimerInTaskList(filteredTasks);
            this.workflow = _.find(workflows, (workflow) => workflow.Id == this.userTaskTimer?.WorkflowId);
        });
    }

    filterTasks(tasks: Task[] = []): any {
        const currDate = new Date();

        let filteredTasks = _.filter(tasks, (task) => {
            if (
                task.ObligationStatus == "Required"
                && task.CompletionStatus == "Incomplete"
                && task.StartDate <= currDate
                && (task.AvailabilityStatus == "Available" || task.AvailabilityStatus == "Locked")
            ) {
                return task;
            }
        });

        return filteredTasks;
    }

    onTaskTimerClick(): void {
        if (this.workflow && this.workflow.IsRunningFor().length) {
            const accountId = ModelUtils.getIdFromDomainId(this.workflow.IsRunningFor()[0].Out);
            this.router.navigate(['Work', 'Account', accountId, 'Workflow', this.workflow.Id]);
        }
    }
};
